import axiosRequest from 'axios'

import { CIS_API_URL } from '@/constants'

export const cisInstance = axiosRequest.create({
  baseURL: `${CIS_API_URL}api`,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
})
